import { EdlLoginComponent, EdlForgotPasswordComponent, EdlResetPasswordComponent } from '@edl-development/edl-auth';
import { SessionService, AuthService, ApplicationTypes } from '@edl-development/edl-common';
import { LoadingComponent } from './loading/loading.component';
import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import {LoginShellComponent} from './login-shell.component';
import { LocalStorageKeys } from '../model/enum/local-storage-keys.enum';



export function onEnter(trans: Transition) {
    var sessionService: SessionService = trans.injector().get(SessionService);

    if (sessionService.isAuthenticated()) {
        if(sessionService.GetSessionValue(LocalStorageKeys.HAS_LOADED_DATA)){
            return trans.router.stateService.target('authenticated.dashboard.view', { loggedInPortal: sessionService.PortalSettings?.URLSubdirectory });
        }
        else {
            return trans.router.stateService.target('public.loading');
        }
    }

    return undefined;
}

export function resolvePasswordResetRequest (transition: Transition, authService: AuthService) {
    const { token } = transition.params();

    return authService
        .validateResetToken(token)
        .toPromise();
}

export let LoginStates: Ng2StateDeclaration[] = [{
    name: 'public.login',
    url: '/login',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.login': {
            component: EdlLoginComponent
        }
    },
    resolve: [{
      token: 'componentHeader',
      deps: [],
      resolveFn: () => 'Login to PAETEP'
    },{
      token: 'AppID',
      deps: [],
      resolveFn: () => ApplicationTypes.EDL_PAETEP
    }],
    onEnter
},
{
  name: 'public.loading',
  url: '/loading',
  views: {
      'content@public': {
          component: LoadingComponent
      }
  }
},
{
    name: 'public.forgot-password',
    url: '/forgot-password',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.forgot-password': {
            component: EdlForgotPasswordComponent
        }
    },
    resolve: [{
        token: 'appId',
        deps: [],
        resolveFn: () => ApplicationTypes.EDL_PAETEP
    }]
}, {
    name: 'public.reset-password',
    url: '/reset-password/:token',
    views: {
        'content@public': {
            component: LoginShellComponent
        },
        'login-content@public.reset-password': {
            component: EdlResetPasswordComponent
        }
    },
    resolve: [{
        token: 'passwordResetRequest',
        deps: [Transition, AuthService],
        resolveFn: resolvePasswordResetRequest
    }]
}]
